import { useGetPurchaseOrdersFeed } from './useGetPurchaseOrdersFeed';

/**
 * Lightweight pending purchase-order total for nav / pill notification dots.
 * Uses feed `{ statusFilter: 'pending', limit: 1 }` and reads `total`.
 *
 * Pass `locationIds` (e.g. the inventory page's location picker selection) so the
 * count matches what the purchase-orders list will show. When omitted, the server
 * scopes the count to the user's authorized locations — never org-wide — so users
 * aren't notified about purchase orders they can't see.
 */
export function usePendingPurchaseOrdersCount(
    enabled = true,
    locationIds?: Array<string> | 'all',
) {
    const feed = useGetPurchaseOrdersFeed(
        {
            statusFilter: 'pending',
            locationIds,
            limit: 1,
        },
        { enabled },
    );

    const total = enabled ? (feed.data?.total ?? 0) : 0;

    return {
        total,
        hasPending: total > 0,
        isLoading: feed.isLoading,
        refetch: feed.refetch,
    };
}
